import React from 'react';

export default function SvgOverviewIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="currentColor" {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2 2V5.5H4.5V2H2ZM4.50062 5.49998C4.50064 5.49997 4.50063 5.49997 4.5006 5.49998L4.50062 5.49998ZM1 2C1 1.44772 1.44772 1 2 1H4.5C5.05228 1 5.5 1.44772 5.5 2V5.5C5.5 6.05228 5.05228 6.5 4.5 6.5H2C1.44772 6.5 1 6.05228 1 5.5V2Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.5 2V3.5H10V2H7.5ZM7.4994 3.49998C7.49937 3.49997 7.49936 3.49997 7.49938 3.49998L7.4994 3.49998ZM6.5 2C6.5 1.44772 6.94772 1 7.5 1H10C10.5523 1 11 1.44772 11 2V3.5C11 4.05228 10.5523 4.5 10 4.5H7.5C6.94772 4.5 6.5 4.05228 6.5 3.5V2Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.5 6.5V10H10V6.5H7.5ZM10.0006 9.99998C10.0006 9.99997 10.0006 9.99997 10.0006 9.99998L10.0006 9.99998ZM6.5 6.5C6.5 5.94772 6.94772 5.5 7.5 5.5H10C10.5523 5.5 11 5.94772 11 6.5V10C11 10.5523 10.5523 11 10 11H7.5C6.94772 11 6.5 10.5523 6.5 10V6.5Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2 8.5V10H4.5V8.5H2ZM1.9994 9.99998C1.99937 9.99997 1.99936 9.99997 1.99938 9.99998L1.9994 9.99998ZM1 8.5C1 7.94772 1.44772 7.5 2 7.5H4.5C5.05228 7.5 5.5 7.94772 5.5 8.5V10C5.5 10.5523 5.05228 11 4.5 11H2C1.44772 11 1 10.5523 1 10V8.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
